import { Avatar, AvatarProps, Theme, withStyles } from '@forgeglobal/design-framework'
import { WithStyles } from 'isolated-design-library'
import { useAppDataQuery } from 'graphql/bindings/AdminBindings'
import React from 'react'

const styles = (theme: Theme) => ({
  avatar: {
    width: theme.spacing(4),
    height: theme.spacing(4),
  },
})

function ProfilePicture(props: AvatarProps & WithStyles<typeof styles>) {
  const { classes, className, ...rest } = props
  const { data } = useAppDataQuery()

  return (
    // TODO: what about when this is loading?
    <Avatar
      {...rest}
      className={[classes.avatar, className].filter(e => e).join(' ')}
      src={(data && data.currentAdmin.profile_picture) || ''}
      alt="Profile picture"
    />
  )
}

export default withStyles(styles)(ProfilePicture)
